// user info
export const STORE_KEY_MOBILE = 'user.mobile'
export const STORE_KEY_ROLE = 'user.role'
export const STORE_KEY_ACCESS_TOKEN = 'user.access_token'
export const STORE_KEY_REFRESH_TOKEN = 'user.refresh_token'
export const STORE_KEY_EMAIL = 'user.email'
export const STORE_KEY_USER_PHOTO = 'user.photo'
